/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { icons } from '../../../../../assets';
import { appHistoryPush } from '../../../../../modules/app/appHistory';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { wizardStorageClearStepsAction } from '../../../../../modules/wizard/wizardActions';
import { EWizardName } from '../../../../../modules/wizard/wizardConstants';
import { CLIENT_ID, IRouteParams, RoutePath } from '../../../../../routes/constants/routesConstants';
import { TableFooterNameType } from '../../../../Table/types/tableTypes';
import { TTableButtonsGetTranslation, TUseTableFooterButtonsUrl } from '../useTableFooterButtons';

const useTableFooterButtonWizardMoneyTransfer = (
    getTranslation: TTableButtonsGetTranslation,
    tableFooterName: TableFooterNameType,
) => {
    const dispatch = useDispatch();

    const { clientId } = useParams<IRouteParams>();

    return {
        className: 'table-footer__link link-money-transfer',
        dataName: 'money-transfer',
        icon: icons.moneyTransferIcon,
        id: AccessComponentKeyEnum.FooterButtonMoneyTransfer,
        ...getTranslation(AccessComponentKeyEnum.FooterButtonMoneyTransfer),

        onClick: useCallback(() => {
            dispatch(wizardStorageClearStepsAction({ wizardName: EWizardName.MONEY_TRANSFER }));
            const urlConfig = mapTableFooterNameToUrl[tableFooterName];
            if (!urlConfig) return;

            appHistoryPush(urlConfig.url.replace(CLIENT_ID, clientId));
        }, [dispatch, tableFooterName, clientId]),
    };
};

const mapTableFooterNameToUrl: Partial<TUseTableFooterButtonsUrl> = {
    [TableFooterNameType.account]: {
        url: RoutePath.moneyTransfer,
        external: '',
    },
    [TableFooterNameType.accountId]: {
        url: RoutePath.moneyTransferAccountId,
        external: '',
    },
};

export default useTableFooterButtonWizardMoneyTransfer;
